var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindsurf = function SvgWindsurf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#windsurf_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "windsurf_svg__b",
    width: 17,
    height: 17,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.617.5h12.566c.948 0 1.717.769 1.717 1.717v12.566c0 .948-.769 1.717-1.717 1.717H2.617A1.717 1.717 0 0 1 .9 14.783V2.217C.9 1.27 1.669.5 2.617.5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#windsurf_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#windsurf_svg__c)",
    d: "M2.617.5h12.566c.948 0 1.717.769 1.717 1.717v12.566c0 .948-.769 1.717-1.717 1.717H2.617A1.717 1.717 0 0 1 .9 14.783V2.217C.9 1.27 1.669.5 2.617.5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#windsurf_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58E5BB",
    d: "m6.825 8.858-.688-1.936c-.069-.192.07-.395.266-.389 3.566.116 5.4 1.338 5.234 5.014-.595-2.512-3.445-2.69-4.812-2.69"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#windsurf_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58E5BB",
    d: "m5.904 5.704-.72-1.886c-.074-.193.064-.402.263-.4 3.614.036 6.159.178 6.159 4.945-.594-2.512-4.335-2.66-5.702-2.66"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#windsurf_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58E5BB",
    d: "m7.77 12.112-.733-2.054c-.068-.19.069-.393.264-.387 2.938.095 4.412 1.28 4.246 4.93-.594-2.512-2.4-2.49-3.777-2.49"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "windsurf_svg__d",
    width: 5.528,
    height: 12.342,
    x: 6.119,
    y: 6.533,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_229_10307"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "windsurf_svg__e",
    width: 6.443,
    height: 12.273,
    x: 5.163,
    y: 3.418,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_229_10307"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "windsurf_svg__f",
    width: 4.54,
    height: 12.258,
    x: 7.02,
    y: 9.671,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_229_10307"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "windsurf_svg__c",
    x1: 0.9,
    x2: 8.9,
    y1: 1.287,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#0F1010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1010"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "windsurf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.9.5h16v16H.9z"
  })))));
};
export default SvgWindsurf;